
<template>
  <div class="login-container">
    <div class="back-shadow"></div>
    <img src="../../assets/img/loginBack.jpg" class="login-back-img" alt="">
    <el-dialog 
      title=""
      custom-class="login-container-dialog"
      width="600px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      :show-close="false"
    >
      <div class="login-header">
        <img src="../../assets/img/login.jpg" alt="" class="logo">
        <div class="shadow">
          <p>总部管理后台系统登录</p>
        </div>
      </div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on" label-position="left">
        <el-form-item prop="account">
          <el-input
            ref="account"
            v-model="loginForm.account"
            placeholder="请输入账号"
            name="account"
            type="text"
            tabindex="1"
            autocomplete="on"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-button :loading="loading" type="primary" @click.native.prevent="handleLogin">登录</el-button>
        <p class="forget-password">忘记密码请联系平台管理员重置</p>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { validUsername, validatePassword } from '@/utils/validate'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
      },
      loginRules: {
        account: [
          { required: true, trigger: 'blur', message: '请输入账号'}
        ],
        password: [
          { required: true, trigger: 'blur', message: '请输入密码'}
        ],
      },
      dialogVisible: false,
      passwordType: 'password',
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {}
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.dialogVisible = true
    })
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.openSliderVerify()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openSliderVerify(){
        const _this = this;
        const captcha = new TencentCaptcha('2083949051',(res) => {
            if (res.ret === 0 && res.errorCode) {
            } else if (res.ret === 0) {
                //验证成功回调
              this.loading = true
              this.$store.dispatch('user/login', {
                ...this.loginForm,
              })
                .then(() => {
                  // 保存当前时间戳
                  localStorage.setItem('powerTime', new Date().getTime());
                  const redirect = this.redirect && this.redirect !== '/401' ? this.redirect : '/'
                  this.$router.push({ path: redirect, query: this.otherQuery })
                  this.loading = true
                })
                .catch(() => {
                  this.loading = false
                  // 重新请求验证码
                })
            }
        }, {
            needFeedBack: false
        })
          captcha.show()
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    }
  }
}
</script>

<style lang="less">
.login-container {
  .el-form-item__content{
    margin-bottom: 30px;
    display: -webkit-box;
  }
  .el-form-item__content{
    margin-bottom: 0;
  }
  .el-input {
    border-radius: 5px;
    display: block;
    height: 45px;
    width: 100%;
    border: 1px solid #DCDFE6;
    -webkit-box-flex: 1;
    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #666;
      height: 47px;
      caret-color: #666;
      box-sizing: border-box;

      &:-webkit-autofill {
        // box-shadow: 0 0 0px 1000px @themeColor inset !important;
        // -webkit-text-fill-color: #ffffff !important;
      }
    }
  }
  button{
    height: 45px;
    border-radius: 5px;
    width:100%;
  }
  .forget-password{
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: center;
    font-size: 12px;
    color: #666;
  }
  .el-form-item__error{
    color: red;
    opacity: 0.8;
  }
  .image-code{
      display: block;
      margin-left: 20px;
      cursor: pointer;
  }
  .login-container-dialog{
    background: transparent;
    .el-dialog__header,.el-dialog__body{
      padding: 0;
    }
    .login-header{
      position: relative;
      border-radius: 5px 5px 0 0;
      overflow: hidden;
      .logo{
        display: block;
        width: 100%;
      }
      .shadow{
        background: rgba(0,0,0,0.3);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        p{
          color: #FFF;
          font-size: 32px;
          font-weight: 700;
          text-align: center;
          letter-spacing: 3px;
          font-style: italic;
          padding-top: 65px;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.login-container {
  height: 100VH;
  width: 100%;
  background-color: #2d3a4b;
  overflow: hidden;
  .back-shadow{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    background: rgba(0,0,0,0.65);
  }
  .login-back-img{
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    display: block;
    margin: auto;
    height: 100%;
  }

  .login-form {
    position: relative;
    width: 100%;
    max-width: 100%;
    padding: 40px 100px 20px;
    background: #FFF;
    box-sizing: border-box;
  }
}
</style>